export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    fixed: 'right',
    width: 100,
    slots: { default: 'opt' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_table_label_processName') || '工艺名称',
    field: 'techName',
    minWidth: 160,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_productionProcesses') || '工序',
    field: 'v_pdProcessDictStep',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_techChargeUnit') || '计价单位',
    field: 'techChargeUnitText',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_state') || '状态',
    width: 100,
    align: 'center',
    slots: { default: 'status' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.creator') || '创建人',
    width: 160,
    align: 'center',
    slots: { default: 'creator' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.modified') || '创建人',
    width: 160,
    align: 'center',
    slots: { default: 'modified' },
    showHeaderOverflow: true,
  },
]
